import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AutoparkService, IAutopark } from '../../services/autopark.service';

interface IAutoparkState {
  currentAutopark: IAutopark | null;
  loading: boolean;
  error: string | null;
}

const initialState: IAutoparkState = {
  currentAutopark: null,
  loading: false,
  error: null,
};

// Асинхронный thunk для получения детальной информации об автопарке
export const fetchAutoparkById = createAsyncThunk<IAutopark, string>(
  'autopark/fetchById',
  async (autoparkId, { rejectWithValue }) => {
    try {
      const response = await AutoparkService.getAutoparkById(autoparkId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Ошибка при загрузке автопарка');
    }
  },
);

// Асинхронный thunk для обновления автопарка
export const updateAutoparkById = createAsyncThunk<IAutopark, { id: string; data: any }>(
  'autopark/updateById',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // Обновляем автопарк
      await AutoparkService.updateAutopark(id, data);

      // После обновления получаем актуальные данные
      const updatedAutopark = await AutoparkService.getAutoparkById(id);
      return updatedAutopark;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Ошибка при обновлении автопарка');
    }
  },
);

const autoparkSlice = createSlice({
  name: 'autopark',
  initialState,
  reducers: {
    clearCurrentAutopark: (state) => {
      state.currentAutopark = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Получение автопарка по ID
      .addCase(fetchAutoparkById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAutoparkById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentAutopark = action.payload;
        state.error = null;
      })
      .addCase(fetchAutoparkById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Обновление автопарка
      .addCase(updateAutoparkById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAutoparkById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentAutopark = action.payload;
        state.error = null;
      })
      .addCase(updateAutoparkById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearCurrentAutopark, clearError } = autoparkSlice.actions;
export default autoparkSlice.reducer;
